<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="dialog">
      <van-field :label="field.options.label" :required="field.options.required" readonly clickable :value="selectedValue"
        :placeholder="field.options.placeholder" @click="showPicker = true" :input-align="field.options.textAlign" />
      <van-dialog v-model="showPicker" :show-confirm-button="false">
        <div slot="title">
          <div>
            {{ field.options.title }}
            <van-icon name="cross" class="close" @click="showPicker = false" />
          </div>
        </div>
        <div slot="default">
          <div style="height: 300px;overflow-y: auto;">
            <van-checkbox-group v-model="result" :max="field.options.maxNum">
              <van-cell-group>
                <van-cell v-for="(item, index) in field.options.optionItems" clickable :key="index" :title="item.label"
                  @click="toggle(index)">
                  <template #right-icon>
                    <van-checkbox :name="item.value" ref="checkboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div class="btns">
            <div @click="cancel">清除</div>
            <div class="confirm" @click="confirm">确认</div>
          </div>
        </div>
      </van-dialog>
    </div>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import { isNull } from "@/utils/util";

export default {
  name: "dialogWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedValue: "",
      showPicker: false,
      fieldModel: "",
      rules: [],
      result: [],
    };
  },
  components: {
    FormItemWrapper,
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initOptionItems()
    this.initEventHandler();

    this.handleOnCreated();

    // this.buildFieldRules();
    this.syncUpdateFormModel("");
    this.buildFieldRules();
    if (this.field.options.required) {
      this.rulesF();
    }
  },
  watch: {
    fieldModel: {
      handler: function (newVal) {
        let val = newVal || []
        if (Object?.prototype?.toString?.apply(val) !== "[object Array]") {
          val = newVal.split(',')
          this.setValue(val);
          return
        }
      },
      deep: true
    },
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    cancel() {
      this.result = []
    },
    confirm() {
      let newList = []
      // 遍历原始列表，获取需要的数据
      this.field.options.optionItems.forEach(item => {
        if (this.result.includes(item.value)) {
          newList.push(item.label)
        }
      })
      this.selectedValue = newList.join(',')
      this.fieldModel = this.result
      this.dispatch("ElFormItem", "el.form.change", [this.fieldModel]);
      this.handleChangeEvent(this.fieldModel);
      this.handleBlurCustomEvent(this.fieldModel);
      this.showPicker = false
    },
    setList(data) {
      this.field.options.optionItems = data
    },
    toggle(index) {
      let value = this.field.options.optionItems[index].value
      let empty = this.result.indexOf('0') > -1
      if (this.field.options.maxNum == 1 || value == '0' || empty) {
        this.result = []
      }
      this.$refs.checkboxes[index].toggle();
    },

    rulesF() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (isNull(value)) {
            _this.aa()

            callback(new Error(
              _this.aa()
            ));
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/vant.scss";

.btns {

  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid rgb(255 135 170);

  >div {
    flex: 1;
    text-align: center;
    cursor: pointer;
    padding: 5px;
  }

  .confirm {
    color: #fff;
    background: rgb(255 135 170);
  }
}

::v-deep .van-dialog__header {
  padding: 10px 0 10px;
}

::v-deep .van-dialog__confirm {
  background-color: rgb(255 135 170);
}

::v-deep .van-cell::after,
::v-deep [class*=van-hairline]::after {
  border: 0 !important;
}

.van-checkbox-group ::v-deep .van-cell {
  border: 0 !important;
}

.el-form-item.is-error .dialog {
  border: 1px solid #f56c6c;
  border-radius: 4px;

  &::v-deep .van-cell {
    border: none;
  }
}

::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #ff87aa;
  border-color: #ff87aa;
}

.close {
  position: absolute;
  right: 15px;
  top: 12px;
  font-size: 18px;
}
</style>
